// extracted by mini-css-extract-plugin
export default {"logo":"Sidebar_logo__TjKSb","logoMin":"Sidebar_logoMin__lxucs","logoMax":"Sidebar_logoMax__FHbZn"};